enum HeaderTheme {
  Dark = "dark",
  Light = "light",
}

export default HeaderTheme;
